import Vue from 'vue'
import Vuex from 'vuex'
import student from './modules/Student'
import courses from './modules/Courses'
import currentschedule from './modules/CurrentSchedule'
import term from './modules/Term'
import status from './modules/Status'


Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    student,
    courses,
    currentschedule,
    term,
    status,
  },
})